export const cafeButtons = [
    {
        id: "zones",
        text: "Зоны чек-листов",
        path: "zones",
    },
    {
        id: "employees",
        text: "Сотрудники",
        path: `employees`,
    },
    {
        id: "table",
        text: "Табель",
        path: `table`,
    },
    {
        id: "faq",
        text: "FAQ",
        path: "faq",
    },
    {
        id: "motivation",
        text: "Мотивация",
        path: "motivation",
    },
    {
        id: "reports",
        text: "Отчеты по чек-листам",
        path: "reports",
    },
    {
        id: "revenueReports",
        text: "Отчеты по выручке",
        path: "revenueReports"
    }
]